import React, { useEffect,useCallback, useRef,useMemo, useState } from 'react';
// import AgGrid from "./AgGrid"
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { columnwithDefs } from "./columnDefs_vehicles";
import Constants from "./Masters_constants";
import redirectURL from "../redirectURL";
import EditItem from './EditItem'
import DeletePartner from './deleteItem'
import SweetAlert from 'react-bootstrap-sweetalert';
import { getHyphenDDMMMYYYYHHMM } from '../common/utils';
import { format } from 'date-fns';
import Select from 'react-select';
import BulkUploadModal from './BulkUploadModal.js';



function Masters() {
    var [rowData, setRowData] = useState([])
    var [columnDefs1, setColumnDefs1] = useState([
        {
            headerName: "Action",
            field: "_id",
            resizable: true,
            width: 90,
            filter: false,
            cellRenderer: EditItem,
            pinned: "left"
            // editable: false
        },
        {
            headerName: "",
            field: "_id",
            width: 50,
            cellRenderer: DeletePartner,
            pinned: "left"
        }
    ])
    const locationMasterColumns =[
        {
            headerName: "City",
            field: "city",
            width: 240,
            filter: true,
        },
        {
            headerName: "State",
            field: "state",
            width: 240,
            filter: true,
    
        },
        {
            headerName: "Type",
            field: "type",
            width: 240,
            filter: true,
        },
        {
            headerName: "Type Name",
            field: "location_name",
            width: 240,
            filter: true,
        },
        {
            headerName: "Customer/Dealer Code",
            field: "location_code",
            width: 240,
            filter: true,
        },
        {
            headerName: "Address",
            field: "address",
            width: 240,
            filter: true,
        },
        {
            headerName: "Pincode",
            field: "pincode",
            width: 240,
            filter: true,
        },
        {
            headerName: "Latitude",
            field: "latitude",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
            
            valueSetter: (params) => {
                const newValue = params.newValue;
                params.data.latitude = newValue; // Set the edited value directly to the data
                return true; // Return true to indicate successful update
            },
        
            valueFormatter: (params) => {
                return validateLatitudeLongitude(params.value); // Use validation function to format value
            },
        
            cellStyle: (params) => {
                const isValid = validateLatitudeLongitude(params.value) !== "Invalid Value";
                
                // If the value is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid latitude
                }
                return null; // Default cell style for valid latitude values
            }
        },
        {
            headerName: "Longitude",
            field: "longitude",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
            
            valueSetter: (params) => {
                const newValue = params.newValue;
                params.data.longitude = newValue; // Set the edited value directly to the data
                return true; // Return true to indicate successful update
            },
        
            valueFormatter: (params) => {
                return validateLatitudeLongitude(params.value); // Use validation function to format value
            },
        
            cellStyle: (params) => {
                const isValid = validateLatitudeLongitude(params.value) !== "Invalid Value";
                
                // If the value is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid longitude
                }
                return null; // Default cell style for valid longitude values
            }
        },
        
        {
            headerName: "Zone",
            field: "zone",
            width: 240,
            filter: true,
        },
        {
            headerName: "Email",
            field: "email",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
            
            valueSetter: (params) => {
                const newValue = params.newValue;
                params.data.email = newValue; // Set the edited value directly to the data
                return true; // Return true to indicate successful update
            },
        
            valueFormatter: (params) => {
                return validateEmail(params.value); // Use validation function to format value
            },
        
            cellStyle: (params) => {
                const isValid = validateEmail(params.value) !== "Invalid Email";
                
                // If the email is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid email
                }
                return null; // Default cell style for valid email addresses
            }
        },
        
        {
            headerName: "Mobile Number",
            field: "mobile_number",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
        
            valueSetter: (params) => {
                const newValue = params.newValue;
        
                // Ensure only 10 digits are allowed
                if (newValue.length > 10) {
                    params.data.mobile_number = newValue.substring(0, 10); // Trim to 10 digits if exceeded
                } else {
                    params.data.mobile_number = newValue;
                }
                return true; // Return true to indicate successful update
            },
        
            valueFormatter: (params) => {
                return validateMobileNumber(params.value); // Use validation function to format value
            },
        
            cellStyle: (params) => {
                const isValid = validateMobileNumber(params.value) !== "Invalid Mobile Number";
        
                // If the mobile number is invalid, apply a red background
                if (!isValid) {
                    return { backgroundColor: "#c85f62" }; // Light red background for invalid mobile number
                }
                return null; // Default cell style for valid mobile numbers
            }
        }
        
        
    ]
    const locationMasterColumns1 =[
        {
            headerName: "City",
            field: "city",
            width: 240,
            filter: true,
        },
        {
            headerName: "State",
            field: "state",
            width: 240,
            filter: true,
    
        },
        {
            headerName: "Type",
            field: "type",
            width: 240,
            filter: true,
        },
        {
            headerName: "Type Name",
            field: "location_name",
            width: 240,
            filter: true,
        },
        {
            headerName: "Customer/Dealer Code",
            field: "location_code",
            width: 240,
            filter: true,
        },
        {
            headerName: "Address",
            field: "address",
            width: 240,
            filter: true,
        },
        {
            headerName: "Pincode",
            field: "pincode",
            width: 240,
            filter: true,
        },
        {
            headerName: "Latitude",
            field: "latitude",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
           
        },
        {
            headerName: "Longitude",
            field: "longitude",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
            
           
        },
        
        {
            headerName: "Zone",
            field: "zone",
            width: 240,
            filter: true,
        },
        {
            headerName: "Email",
            field: "email",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
            
            
        },
        
        {
            headerName: "Mobile Number",
            field: "mobile_number",
            width: 240,
            filter: true,
            editable: true,
            headerClass: 'bold-header',
        }
        
        
    ]
    

    var [columnDefs, setColumnDefs] = useState([...columnDefs1, ...locationMasterColumns1])

    // var [showloaderbg, setshowloaderbg] = useState("show-m");
    const gridApiConsignments = useRef();
    const columnApiConsignments = useRef(null);
    var [showloader, setshowloader] = useState("show-m");
    var [showAddSlider, setshowAddSlider] = useState("");
    var [overlay, setoverlay] = useState("show-n");
    var [rowid ,setRowId] = useState();
    var [sliderText, setSliderText] = useState("");
    const [isEditMode, setIsEditMode] = useState(false);
    var [error1, setError1] = useState("");
    var [error, setError] = useState("");

    var [location, setLocation] = useState({
        dealerCode:'',
        typeName:'',
        city:'',
        state:'',
        address:'',
        pincode:"",
        latitude:'',
        longitude:'',
        zone:'',
    })
    var [email, setEmail] = useState("");
    var [mobileNumber, setMobileNumber] = useState("");
    var [Type, setType] = useState([
        {value:"Factory", label:"Factory"},
        {value:"Warehouse", label:"Warehouse"},
        {value:"Customer", label:"Customer"},
        {value:"Dealer", label:"Dealer"},
    ])
    var [selectType, setSelectType] = useState({
        label:'Factory', value:"Factory"
    })
    var [vehicle_type, setvehicletype] = useState("");
    var [is_active, setstatus] = useState("");
    // var modules = useState(AllModules);
    var paginationPageSize = useState(50);
    var [locationLength, setLocationLength] = useState("");
    var [consignerCoordinates, setConsignerCoordinates] = useState("");
    var [show, setShow] = useState(false);
    var [basicType, setBasicType] = useState("");
    var [basicTitle, setBasicTitle] = useState("");
    var [deleteConfirmationSlide, setDeleteConfirmationSlide] = useState("");
    var [deleteRowData, setDeleteRowData] = useState("");
    

    const defaultColDef = useMemo(() => {
        return {
            //flex: 1,
            resizable:true,
            sortable: true,
            filter: true,
            editable:false

        };
    }, []);

    var onGridReady = (params) => {
        // gridApi = params.api;
		// gridColumnApi = params.columnApi;
        console.log('params',params)
        console.log('Grid Ready. Column API:', params.columnApi);
        // gridApiRef.current = params.api; 
        // gridColumnApiRef.current = params.columnApi;
    }

    const onGridReadyConsignments = useCallback((params) => {
        gridApiConsignments.current = params.api
        columnApiConsignments.current = params.columnApi
    }, []);

    const getCurrentFormattedDate = () => {
        const date = new Date();
        return format(date, 'dd-MM-yyyy');
    };

    const getCurrentISODate = () => {
        const date = new Date();
        return date.toISOString();
    };

    useEffect(() => {
        setTimeout(() => {
            // setshowloaderbg("show-n")
            setshowloader("show-n")
        }, 2000)
        loadData();

        // 
    }, [])

    var loadData = async () => {
        var parameters = {}
        await redirectURL.post('/getLocationDetails', parameters)
            .then(response => {
                if (response.data.status == "success") {
                    
                    setRowData(response.data.records);
                    setLocationLength(response.data.records.length);

                }
                // setshowloaderbg("show-n");
                setshowloader("show-n");

            })
            .catch(error => console.error('Error fetching data:', error));
    }
    var onClickDeleteItem = async (rownode) => {
        // console.log("Rownode Update", rownode);
        setDeleteConfirmationSlide("slide95")
        setoverlay("show-m")
        setDeleteRowData(rownode)
    };

    var onsubmitdelete = async (rownode) => {
        // console.log("Rownode Update", rownode);
        var params = {
            row_id: deleteRowData.data._id
        }
    
        try {
            const resp = await redirectURL.post('/deleteLocationDetails', params);
            console.log(resp,"resp",resp.data.status,"success");
            
            if (resp.data.status === "success") {
                setDeleteConfirmationSlide("")
                setoverlay("show-n");
                setshowloader("show-n");
                setShow(true);
                setBasicTitle("Location Deleted Successfully");
                setBasicType("success");
                loadData();
            }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    var hideDeleteSubmit = ()=>{
        setDeleteConfirmationSlide("");
        setoverlay("show-n");
    
    }

    var showAddBlock = async (rownode) => {
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m")
        setSliderText("Add Location");
        setLocation({
            dealerCode:'',
            typeName:'',
            city:'',
            state:'',
            address:'',
            pincode:"",
            latitude:'',
            longitude:'',
            zone:'',
        })
        setSelectType({label:'Factory', value:"Factory"})
        setEmail("");
        setMobileNumber("");
        setIsEditMode(false);

    }

    var onClickEditBlock  = async (rownode) =>{
        setshowAddSlider("slider-translate-30p");
        setoverlay("show-m");
        setSliderText("Edit Location");
        setRowId(rownode.data._id);
        setLocation({
            dealerCode:rownode.data.location_code,
            typeName:rownode.data.location_name,
            city:rownode.data.city,
            state:rownode.data.state,
            address:rownode.data.address,
            pincode:rownode.data.pincode,
            latitude:rownode.data.latitude,
            longitude:rownode.data.longitude,
            zone:rownode.data.zone,
        })
        setSelectType({label:rownode.data.type, value:rownode.data.type})
        setEmail(rownode.data.email);
        setMobileNumber(rownode.data.mobile_number);
        setIsEditMode(true);
    }

    var hideAll = () => {
        setoverlay("show-n");
        setshowAddSlider("");
    }


    var saveMasterForm = async (e) => {
        e.preventDefault();
        let user_email = localStorage.getItem('email');
        // setshowloaderbg("show-m");
        const createdDate = getCurrentISODate();
        console.log(createdDate, "pp");
        
        setshowloader("show-m")
        if(isEditMode) {
            var params = {
                rowid: rowid,
                city: location.city,
                state: location.state,
                type: selectType.label,
                address: location.address,
                pincode:location.pincode,
                latitude:location.latitude,
                longitude: location.longitude,
                zone: location.zone,
                email: email,
                mobile_number: mobileNumber,
                location_name: location.typeName,
                location_code: location.dealerCode,
                // is_active: is_active,
                modified_date: createdDate,
            }
        }
        else {
            var params = {
                city: location.city,
                state: location.state,
                type: selectType.label,
                location_name: location.typeName,
                location_code: location.dealerCode,
                address: location.address,
                pincode:location.pincode,
                latitude:location.latitude,
                longitude: location.longitude,
                zone: location.zone,
                email: email,
                mobile_number: mobileNumber,
                // is_active: is_active,
                created_date: createdDate,
                consigner_coordinates: consignerCoordinates
                // location_code: `L${locationLength + 1}`

            }
            if(error!==""){
                setShow(true);
                setBasicTitle("Please enter the valid email");
                setBasicType("danger");
                setshowloader("show-n")
                return;
            }
            if(error1!==""){
                setShow(true);
                setBasicTitle("Please enter the valid mobile number");
                setBasicType("danger");
                setshowloader("show-n")

                return;
            }
        }
        
        console.log(params, "params");
        console.log(isEditMode, "edit mode");
        if (isEditMode) {
            await redirectURL.post('/updateLocationMaster', params).then((resp) => {
                console.log(resp, "edit response");
                if (resp.data.status == "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setstatus("");
                    setIsEditMode(false);
                    setRowId("");
                    setShow(true);
                    setBasicTitle("Updated Location Data");
                    setBasicType("success");
                    loadData();
                    setLocation({
                        typeName:'',
                        dealerCode:'',
                        city:'',
                        state:'',
                        address:'',
                        pincode:"",
                        latitude:'',
                        longitude:'',
                        zone:'',
                    })
                    setSelectType({label:'Factory', value:"Factory"})
                    setEmail("");
                    setMobileNumber("");
                }
            });
        } else {
            await redirectURL.post('/addLocation', params).then((resp) => {
                if (resp.data.status == "success") {
                    setoverlay("show-n");
                    setshowAddSlider("");
                    setshowloader("show-n");
                    setShow(true);
                    setBasicTitle("Added Location Data");
                    setBasicType("success");
                    loadData();
                    setLocation({
                        typeName:'',
                        dealerCode:'',
                        city:'',
                        state:'',
                        address:'',
                        pincode:"",
                        latitude:'',
                        longitude:'',
                        zone:'',
                    })
                    selectType({label:'Factory', value:"Factory"})
                    setEmail("");
                    setMobileNumber("");
                    setstatus("");
                    setIsEditMode(false);
                    setShow(true);
                    setBasicTitle("Added Location Data");
                    setBasicType("success");
                    loadData();
                    setError("")
                    setError1("")
                } else if (resp.data.status === "failure") {
                    setoverlay("show-n");
                    setshowloader("show-n");
                    setIsEditMode(false);
                    setshowAddSlider("");
                    setstatus("");
                    setShow(true);
                    setBasicTitle(resp.data.message);
                    setBasicType("danger");
                    setLocation({
                        typeName:'',
                        dealerCode:'',
                        city:'',
                        state:'',
                        address:'',
                        pincode:"",
                        latitude:'',
                        longitude:'',
                        zone:'',
                    })
                    selectType({label:'Factory', value:"Factory"})
                    setEmail("");
                    setMobileNumber("");
                    setError("")
                    setError1("")
                }
            }).catch(err => {
            });
        }
    };
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const onClickOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
        setoverlay("show-m")
    };

    const closeBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setoverlay("show-n")
    };

    
         
    const onSelectType  =(e)=>{
        setSelectType(e)
    }    
    // const emailValidation = (e) => {
    //     const emailValue = e.target.value;
    //     const emailPattern = /^[a-zA-Z0-9._%+-]+@(gmail\.com|.*\.in)$/;
    
    //     // Check if the email matches the required pattern
    //     if (emailPattern.test(emailValue)) {
    //         console.log(emailValue, "emailValue");
            
    //         setEmail(emailValue);  // Set the email value directly since it is valid
    //         setError('');  // Clear the error message if the email is valid
    //     } else {
    //         setEmail(emailValue);  // Update the email state even if it is invalid
    //         setError('Invalid email. It should end with @gmail.com or .in');
    //     }
    // };
    const emailValidation = (e) => {
        const emailValue = e.target.value;

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (emailPattern.test(emailValue)) {
            setEmail(emailValue);
            setError('');
        } else {
            setEmail(emailValue);
            setError('Invalid email format');
        }
    };
    const handleDriverNumberChange = (e) => {
        const { name, value } = e.target;
      
        // Allow only numeric input
        const numericValue = value.replace(/\D/g, '').slice(0, 10);
      
        // Update the state with the new value (allow only 10 digits max)
        setMobileNumber(numericValue);
    
        // Validate the input length and content
        if (numericValue.length < 10 && numericValue.length > 0) {
          setError1('Mobile number must be 10 digits long');
        } else if (numericValue.length === 10 && /^[6-9]\d{9}$/.test(numericValue)) {
          setError1(''); // Clear error if the number is valid
        } else if (numericValue.length === 10 && !/^[6-9]/.test(numericValue)) {
          setError1('Mobile number must start with a digit between 6 and 9');
        } else if (numericValue.length > 10) {
          setError1('Mobile number cannot exceed 10 digits');
        }
    };
    const handlePincodeChange = async (e) => {
        const pincode = e.target.value;
    
        // Update the state
        setLocation((prevState) => ({
            ...prevState,
            pincode: pincode,
        }));
    
        // Fetch records using the redirectURL function
        var params = {
            pincode: pincode
        }
    
        try {
            const resp = await redirectURL.post('/getPincodeCoordinates', params);
            console.log(resp,"resp",resp.data.status,"success");
            setConsignerCoordinates(resp.data.data)
            
            // if (resp.data.status === "success") {
            //     setoverlay("show-n");
            //     setshowloader("show-n");
            //     setShow(true);
            //     setBasicTitle("Location Deleted Successfully");
            //     setBasicType("success");
            //     loadData();
            // }
        } catch (error) {
            console.error("Error deleting vehicle details:", error);
        }
    };
    
    
  

    return (
        <div>
            <div className="container-fluid">
                <SweetAlert
                    show={show}
                    type={basicType}
                    title={basicTitle}
                    onConfirm={() => {
                        setShow(false)
                    }}>
                </SweetAlert>


            </div>
            <div className="container-fluid">
    {/* Row for Heading and Buttons */}
    <div className="row align-items-center justify-content-between mb-3">
        {/* Heading */}
        <div className="col-auto">
            <h5 className="f18 d-flex align-items-center master-title">
                <i className="icofont icofont-vehicle-delivery-van cus-i"></i>
                &nbsp;Location Master
            </h5>
        </div>

        {/* Buttons */}
        <div className="col-auto d-flex">
            {/* <button
                title="Bulk Upload"
                onClick={onClickOpenBulkUploadModal}
                className="btn btn-warning mr-2"
                type="button"
                style={{ padding: "8px 15px", height: "35px" }}
            >
                <i className="fa fa-upload"></i>&nbsp;Upload Locations
            </button> */}

            <BulkUploadModal
                show={showBulkUploadModal}
                onClose={closeBulkUploadModal}
                columnDefs={locationMasterColumns}
                screen={"location_master"}
                templateUrl={require('../../assets/json/location_master_template.csv')}
            />

            {Constants.VEHICLES.BTN_ADD === 1 && (
                <button
                    className="btn btn-warning"
                    onClick={showAddBlock}
                    style={{ padding: "8px 15px", height: "35px" }}
                >
                    <i className="icon-plus"></i>&nbsp;Add Location
                </button>
            )}
        </div>
    </div>

    {/* Grid */}
    <div className="row">
        <div className="col-xl-12 col-md-12 xl-60">
            <div className="card">
                <div className="card-body">
                    <div
                        className="ag-theme-balham mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <AgGridReact
                            columnDefs={columnDefs}
                            rowData={rowData}
                            defaultColDef={defaultColDef}
                            pagination={true}
                            paginationPageSize={50}
                            onGridReady={onGridReadyConsignments}
                            enableRangeSelection={true}
                            enableCellContextMenu={true}
                            masterDetail={true}
                            context={{ onClickEditBlock, onClickDeleteItem }}
                            sideBar={{
                                toolPanels: [
                                    {
                                        id: "columns",
                                        labelDefault: "Columns",
                                        labelKey: "columns",
                                        iconKey: "columns",
                                        toolPanel: "agColumnsToolPanel",
                                        toolPanelParams: {
                                            suppressPivotMode: true,
                                            suppressRowGroups: true,
                                            suppressValues: true,
                                        },
                                    },
                                    {
                                        id: "filters",
                                        labelDefault: "Filters",
                                        labelKey: "filters",
                                        iconKey: "filter",
                                        toolPanel: "agFiltersToolPanel",
                                    },
                                ],
                            }}
                            statusBar={{
                                statusPanels: [
                                    {
                                        statusPanel: "agTotalAndFilteredRowCountComponent",
                                        align: "left",
                                    },
                                    {
                                        statusPanel: "agTotalRowCountComponent",
                                        align: "center",
                                    },
                                    { statusPanel: "agFilteredRowCountComponent" },
                                    { statusPanel: "agSelectedRowCountComponent" },
                                    { statusPanel: "agAggregationComponent" },
                                ],
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"slide-r " + showAddSlider}>
                <div className="slide-r-title">
                    <h4 className="slide-r-title">{sliderText}
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={hideAll} >X</span>

                    </h4>

                </div>
                <div className="slide-r-body">

                    <form className="" style={{ padding: "20px" }} onSubmit={saveMasterForm}>
                    <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Type
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <Select placeholder={""}  value={selectType} className="border-radius-0" onChange={onSelectType} style={{ borderRadius: "0px" }} options={Type} 
                            />

                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Type Name
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <input type="text" name="city" value={location.typeName} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} 
                            onChange={(e) => setLocation(prevState => ({
                                ...prevState,
                                typeName: e.target.value
                            }))}                             
                            required={!isEditMode}
                            autoComplete='off'
                            />                            

                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Customer/Dealer Code
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <input type="text" name="city" value={location.dealerCode} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} 
                            onChange={(e) => setLocation(prevState => ({
                                ...prevState,
                                dealerCode: e.target.value
                            }))}                             
                            required={!isEditMode}
                            autoComplete='off'
                            />                            

                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>City
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <input type="text" name="city" value={location.city} style={{
                                width: "100%",
                                padding: "10px",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                            }} 
                            onChange={(e) => setLocation(prevState => ({
                                ...prevState,
                                city: e.target.value
                            }))}                             
                            required={!isEditMode}
                            autoComplete='off'
                            />
                        </div>

                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>State
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}                                </label>
                            <input
                                type="text"
                                name="state"
                                id="state"
                                value={location.state}
                                onChange={(e) => setLocation(prevState => ({
                                    ...prevState,
                                    state: e.target.value
                                }))}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                        </div>
                     
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Address
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="Address"
                                id="address"
                                value={location.address}
                                onChange={(e) => setLocation(prevState => ({
                                    ...prevState,
                                    address: e.target.value
                                }))}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Pincode
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="pincode"
                                id="pincode"
                                value={location.pincode}
                                onChange={handlePincodeChange}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Latitude
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="latitude"
                                id="latitude"
                                value={location.latitude}
                                onChange={(e) => setLocation(prevState => ({
                                    ...prevState,
                                    latitude: e.target.value
                                }))}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Longitude
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="longitude"
                                id="longitude"
                                value={location.longitude}
                                onChange={(e) => setLocation(prevState => ({
                                    ...prevState,
                                    longitude: e.target.value
                                }))}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Zone
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="zone"
                                id="zone"
                                value={location.zone}
                                onChange={(e) => setLocation(prevState => ({
                                    ...prevState,
                                    zone: e.target.value
                                }))}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                        </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Email
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="email"
                                id="email"
                                value={email}
                                onChange={emailValidation}
                                                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                            {error && <span style={{ color: 'red', fontSize:"10px" }}>{error}</span>}                                                        
                            </div>
                        <div className="form-group">
                            <label style={{ display: "block", marginBottom: "5px" }}>Mobile Number
                            {!isEditMode && <span style={{ color: 'red' }}>*</span>}
                                </label>
                            <input
                                type="text"
                                name="mobile_number"
                                id="mobile_number"
                                value={mobileNumber}
                                onChange={handleDriverNumberChange}                                  
                                required={!isEditMode}
                                // disabled={isEditMode}
                                 style={{
                                    width: "100%",
                                    padding: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#f9f9f9",
                                }}
                                autoComplete='off'

                            />
                            {error1 && <span style={{ color: 'red', fontSize:"10px" }}>{error1}</span>}                                                        

                        </div>
                   

                        {isEditMode ?  
                        <>
                        <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Update Location</button>
                        </div>
                        </>
                        :
                        <>
                         <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Location</button>
                        </div>
                        </> 
                         } 
                        {/* <div className="form-group" style={{ textAlign: "center" }}>
                            <button type="submit" className="btn btn-success"
                                style={{
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "4px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                }}
                            >Add Transporter</button>
                        </div> */}

                    </form>
                </div>

            </div>
            {deleteConfirmationSlide
                 && 
                 <div className={"sliderBlock3 " + (deleteConfirmationSlide)} >
                <span className="float-right ffclosebtn1" style={{ marginRight: "25px", fontSize: '20px' }} onClick={hideDeleteSubmit} >
                    <img src={require('../../assets/images/closeIcon.png')} className='closeIcon mt-5p' style={{ marginTop: "-40px" }} />
                </span>
                <div className='d-flex mt-60p' style={{marginLeft:"42px"}}>
                            <div className='d-flex flex-column ml-20p'>
                                <h1 className='confirm-heading'>Are you sure you want to delete ?</h1>
                            </div>
                </div>                
                <div className='d-flex flex-row ml-30p mt-20p'>
                    <button className='btn_confirm_cancel' style={{ marginRight: "36px", marginLeft: "15px" }} onClick={hideDeleteSubmit} >Cancel</button>
                    <button className='btn_hover8' onClick={onsubmitdelete}>Delete</button>
                </div>

                </div>} 

            <div className={"dataLoadpage " +(showloader)}>
                </div>
                <div className={"dataLoadpageimg " +(showloader)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (overlay)} style={{ zIndex: "10" }}
                ></div>

        </div>
    );
}

function validateMobileNumber(number) {
    // Regular expression for a 10-digit number starting with 6, 7, 8, or 9
    const mobilePattern = /^[6-9]\d{9}$/;
    
    if (number.length > 10) {
        return "Invalid Mobile Number"; // If length is more than 10 digits, return invalid
    }

    if (mobilePattern.test(number)) {
        return number; // If the mobile number is valid, return it as is
    }

    return "Invalid Mobile Number"; // Return this string for invalid numbers
}

function validateEmail(email) {
    // Regular expression to check if the email ends with @gmail.com or @gmail.in
    const emailPattern = /^[a-zA-Z0-9._%+-]+@(gmail\.com|gmail\.in)$/;
    
    if (emailPattern.test(email)) {
        return email; // If the email is valid, return it as is
    }
    return "Invalid Email"; // Return this string for invalid emails
}

function validateLatitudeLongitude(value) {
    // Check if the value is a valid float or integer
    const floatPattern = /^-?\d+(\.\d+)?$/; // Regex for float or integer
    
    if (floatPattern.test(value)) {
        return value; // If the value is valid, return it as is
    }
    return "Invalid Value"; // Return this string for invalid values
}




export default Masters;
